module.exports = __webpack_public_path__ + "static/media/adela.e116a4ee.jpg";